import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createBlock as _createBlock, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-6d4ab297"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "head-top"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "iconfont icon-fanhui"
}, null, -1));
const _hoisted_3 = {
  class: "head-infor"
};
const _hoisted_4 = {
  key: 0,
  class: "head-login"
};
const _hoisted_5 = ["href"];
const _hoisted_6 = {
  class: "el-dropdown-link"
};
const _hoisted_7 = {
  class: "user-info"
};
const _hoisted_8 = ["src"];
const _hoisted_9 = {
  class: "user-name"
};
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  underline: false,
  target: "_self"
}, "退出", -1));
import { defineComponent, ref, reactive, inject } from 'vue';
import { setStorage, getStorage } from '@/plugins/store';
export default {
  __name: 'index',
  props: {
    backTitle: {
      type: String,
      default: '返回'
    }
  },
  setup(__props) {
    const $http = inject('$http');
    const $utils = inject('$utils');

    // 获取用户信息
    const userInfo = ref(null);
    async function getUserInfo() {
      let token = $utils.getCookie('X-Access-Token');
      if (token) {
        const res = await $http.getUserInfo();
        userInfo.value = res;
        setStorage('userInfo', res);
        return;
      }
      return null;
    }
    getUserInfo();

    // 获取项目基本信息
    const projectInfo = ref(null);
    const getBaseInfo = () => {
      projectInfo.value = getStorage('projectBaseData');
      console.log('projectInfo', projectInfo.value);
    };
    getBaseInfo();
    const loginUrl = computed(() => {
      return `/login.html?service=${encodeURIComponent(window.location.href)}`;
    });
    const handleBack = () => {
      window.history.back();
      // window.location.href = localStorage.getItem('currentUrl')
    };

    // 退出登录
    const logout = () => {
      $http.logOut().then(res => {
        console.log('logout', res);
        $utils.delCookie('X-Access-Token');
        window.location.href = loginUrl.value;
      });
    };
    return (_ctx, _cache) => {
      const _component_arrow_down = _resolveComponent("arrow-down");
      const _component_el_icon = _resolveComponent("el-icon");
      const _component_el_link = _resolveComponent("el-link");
      const _component_el_dropdown_item = _resolveComponent("el-dropdown-item");
      const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu");
      const _component_el_dropdown = _resolveComponent("el-dropdown");
      return _openBlock(), _createElementBlock("div", {
        class: "header",
        style: _normalizeStyle({
          'background-image': `url(${projectInfo.value.home_head_bg_url || '//image.zhihuishu.com/zhs/ablecommons/zhangying/202104/5c054f3a7c804fc5829b114cc174c17d.png'})`
        })
      }, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", {
        class: "head-left",
        onClick: handleBack
      }, [_hoisted_2, _createElementVNode("span", null, _toDisplayString(__props.backTitle), 1)]), _createElementVNode("div", _hoisted_3, [!userInfo.value ? (_openBlock(), _createElementBlock("div", _hoisted_4, [_createElementVNode("a", {
        href: _unref(loginUrl)
      }, "登录", 8, _hoisted_5)])) : (_openBlock(), _createBlock(_component_el_dropdown, {
        key: 1,
        class: "head-user"
      }, {
        dropdown: _withCtx(() => [_createVNode(_component_el_dropdown_menu, null, {
          default: _withCtx(() => [userInfo.value.roleId ? (_openBlock(), _createBlock(_component_el_dropdown_item, {
            key: 0
          }, {
            default: _withCtx(() => [_createVNode(_component_el_link, {
              underline: false,
              target: "_blank",
              href: "/admin"
            }, {
              default: _withCtx(() => [_createTextVNode("管理后台")]),
              _: 1
            })]),
            _: 1
          })) : _createCommentVNode("", true), _createVNode(_component_el_dropdown_item, null, {
            default: _withCtx(() => [_createVNode(_component_el_link, {
              underline: false,
              href: `/setting.html`
            }, {
              default: _withCtx(() => [_createTextVNode("账号设置")]),
              _: 1
            }, 8, ["href"])]),
            _: 1
          }), _createVNode(_component_el_dropdown_item, {
            onClick: logout
          }, {
            default: _withCtx(() => [_hoisted_10]),
            _: 1
          })]),
          _: 1
        })]),
        default: _withCtx(() => [_createElementVNode("span", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_createElementVNode("img", {
          class: "avatar",
          src: userInfo.value.avatar ? _ctx.$fileHost + userInfo.value.avatar : require('@/assets/images/user_icon.png')
        }, null, 8, _hoisted_8), _createElementVNode("span", _hoisted_9, _toDisplayString(userInfo.value.realname), 1)]), _createVNode(_component_el_icon, {
          class: "el-icon--right toggle-arrow-span"
        }, {
          default: _withCtx(() => [_createVNode(_component_arrow_down)]),
          _: 1
        })])]),
        _: 1
      }))])])], 4);
    };
  }
};